




import {
  defineComponent,
  ref,
  onUnmounted,
  onMounted,
} from "@vue/composition-api"
import { FacilityModel } from "@/app/models/facility.model"
import { api } from "@/app/api"
import { BookingModel } from "@/app/models/booking.model"
import { HttpResponse } from "@/app/api/request"

export default defineComponent({
  props: {
    booking: {
      type: Object as () => BookingModel,
      required: true,
    },
    facility: FacilityModel,
  },
  setup: (props: { booking: BookingModel; facility: FacilityModel }) => {
    const parkPriceString = ref<string>("")

    const timeInterval = setInterval(() => calcNewParkPriceString(), 60 * 1000)

    function calcNewParkPriceString() {
      if (props.booking.startedAt) {
        api
          .getBookingPrice(props.booking)
          .then((response: HttpResponse<BookingModel>) => {
            if (response.data) {
              parkPriceString.value = formatPrice(response.data.price / 100)
            }
          })
      } else {
        parkPriceString.value = "-"
      }
    }

    function formatPrice(price: number): string {
      if (price % 1 != 0) {
        return `CHF ${price}0`
      }
      return `CHF ${price}.–`
    }

    onMounted(() => calcNewParkPriceString())
    onUnmounted(() => clearInterval(timeInterval))

    return { parkPriceString }
  },
})
